import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

export const TileContentGreyBackground = ({
  children,
  minHeight = 120,
  fullHeight = false,
}: {
  children: ReactNode;
  minHeight?: number;
  /**
   * Grow to fill a flex-column parent instead of hugging its content. Lets the
   * empty state fill a stretched card so it doesn't leave dead space below it.
   */
  fullHeight?: boolean;
}) => {
  const theme = useTheme();
  const isChildrenPrimitive = typeof children !== "object";
  return (
    <Box
      sx={{
        px: 1,
        py: 1,
        minHeight: minHeight,
        textAlign: "center",
        backgroundColor: theme.palette.grey50.main,
        borderRadius: 1,
        ...(fullHeight ? { flexGrow: 1, display: "flex", flexDirection: "column" } : {}),
      }}
    >
      {isChildrenPrimitive ? (
        // Display primitives centered in the box
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};
